import React from 'react';
import { ModalDialog } from '../modalDialog';
import { ModalBaseProps } from '../modalDialog/ModalDialog';

interface AlertDialogProps extends ModalBaseProps {
  onDismiss: () => void;
  maxWidth?: number;
  buttonCaption?: string;
}

const AlertDialog: React.FC<AlertDialogProps> = (props: AlertDialogProps) => {
  const { buttonCaption = 'Ok, got it' } = props;
  return (
    <ModalDialog
      title={props.title}
      isOpen={props.isOpen}
      showCloseButton={false}
      onClose={props.onDismiss}
      button1={{
        caption: buttonCaption,
        onClick: props.onDismiss,
      }}
      maxWidth={props.maxWidth}
    >
      {props.children}
    </ModalDialog>
  );
};

export default AlertDialog;
